// static metric menu type for charts
export const CHART_METRIC_MENU_TYPE = 'history';
// correlations type constants
export const RATIO = 'ratio';
export const SPREAD = 'spread';
export const CORRELATION = 'correlation';
export const CORRELATION_FIRST_SECURITY = '_firstSecurity_';
export const CORRELATION_LIST_SECURITY = '_listSecurity_';
export const CORRELATION_SECURITY_OPTIONS = [CORRELATION_FIRST_SECURITY, CORRELATION_LIST_SECURITY];
// Correlation validation rules
export const DEFAULT_LAG = 0;
export const DEFAULT_WEIGHT = 1;
export const MAX_LAG = 100;
export const MAX_WEIGHT = 100;
export const MIN_LAG = 0;
export const MIN_WEIGHT = -100;
// Correlation lookback window range
export const MIN_LOOKBACK_WINDOW = 1;
export const MAX_LOOKBACK_WINDOW = 252;
